import preferenceGroups from "./preferenceGroups";

export default function isPreferenceGroupVisible(groupName, menuVisibility) {
  const group = preferenceGroups[groupName];

  if (!group) return false;

  return Boolean(menuVisibility?.[group.menuKey]);
}
